import ADPLogo from '@perpay-web/fintech/assets/images/ADPLogo.png';
import AurisLogo from '@perpay-web/fintech/assets/images/AurisLogo.png';
import GustoLogo from '@perpay-web/fintech/assets/images/GustoLogo.png';
import paychexLogo from '@perpay-web/fintech/assets/images/PaychexSmallLogo.png';
import paylocityLogo from '@perpay-web/fintech/assets/images/paylocityLogo.png';

export enum PAYROLL_PROVIDER {
    PAYCHEX = 'paychex',
    ADP = 'adp',
    PAYLOCITY = 'paylocity',
    GUSTO = 'gusto',
    AURIS = 'auris',
}

const PAYROLL_PROVIDER_NAMES: {
    [key in PAYROLL_PROVIDER]: string;
} = {
    [PAYROLL_PROVIDER.PAYCHEX]: 'Paychex',
    [PAYROLL_PROVIDER.ADP]: 'ADP',
    [PAYROLL_PROVIDER.PAYLOCITY]: 'Paylocity',
    [PAYROLL_PROVIDER.GUSTO]: 'Gusto',
    [PAYROLL_PROVIDER.AURIS]: 'Auris',
};

type PayrollProvider = {
    name: (typeof PAYROLL_PROVIDER_NAMES)[PAYROLL_PROVIDER];
    value: PAYROLL_PROVIDER;
    logo: string;
};

export const SUGGESTED_PAYROLL_PROVIDERS: PayrollProvider[] = [
    {
        name: PAYROLL_PROVIDER_NAMES[PAYROLL_PROVIDER.PAYCHEX],
        value: PAYROLL_PROVIDER.PAYCHEX,
        logo: paychexLogo,
    },
    {
        name: PAYROLL_PROVIDER_NAMES[PAYROLL_PROVIDER.ADP],
        value: PAYROLL_PROVIDER.ADP,
        logo: ADPLogo,
    },
    {
        name: PAYROLL_PROVIDER_NAMES[PAYROLL_PROVIDER.PAYLOCITY],
        value: PAYROLL_PROVIDER.PAYLOCITY,
        logo: paylocityLogo,
    },
    {
        name: PAYROLL_PROVIDER_NAMES[PAYROLL_PROVIDER.GUSTO],
        value: PAYROLL_PROVIDER.GUSTO,
        logo: GustoLogo,
    },
    {
        name: PAYROLL_PROVIDER_NAMES[PAYROLL_PROVIDER.AURIS],
        value: PAYROLL_PROVIDER.AURIS,
        logo: AurisLogo,
    },
];
